/* yct-picker.js -- YCT product option picker.
   The product sections are 54KB/78KB, so rather than editing them this
   replaces their option controls and drives the theme's own variant-selects
   underneath: it writes to the native option selects and fires change, which
   updates price, variant id, URL and the buy button.
   Size categories are NOT a 4th Shopify option (only 3 allowed; Colour,
   Size and Sleeve use them). They are a front-end filter over the Size
   values: 2T-5T Toddlers, Y* Youth, rest Adults. A category or sleeve step
   renders only if the product has those values, so this works unchanged on
   adults-only products and gains the rest as variants are added. */
(function(){
'use strict';
var SWATCH={bay:'#6FA8A0',black:'#1A1A1A',denim:'#4C6A92',espresso:'#4A3728',granite:'#8F8C86',graphite:'#4A4A4A',grey:'#B8B4AD',gray:'#B8B4AD',ivory:'#F2E8D5',midnight:'#1F2A44',moss:'#6B7A4F',navy:'#1F3250',pepper:'#5A5750',sage:'#9CA986',white:'#FFFFFF',berry:'#8C2F4A'};
var LABEL={adults:'Adults',youth:'Youth',toddlers:'Toddlers'};
var ORDER=['adults','youth','toddlers'];
var YOUTH=['YXS','YS','YM','YL','YXL','YXXL'];

function group(v){var u=String(v).toUpperCase();
  if(u.length>1&&u.charAt(u.length-1)==='T'&&!isNaN(parseInt(u,10)))return 'toddlers';
  if(YOUTH.indexOf(u)!==-1)return 'youth';
  return 'adults';}
function sel(n){return document.querySelector("select[name='options["+n+"]']");}
function vals(s){return Array.prototype.filter.call(s.options,function(o){return o.value;}).map(function(o){return o.value;});}
function set(s,v){if(!s||s.value===v)return;s.value=v;s.dispatchEvent(new Event('change',{bubbles:true}));}
function el(t,c,txt){var e=document.createElement(t);if(c)e.className=c;if(txt!=null)e.textContent=txt;return e;}

function step(labelText,qualText){
  var w=el('div','yct-pick__step');
  var l=el('p','yct-pick__label',labelText);
  if(qualText){var q=el('span','yct-pick__qual',qualText);l.appendChild(q);}
  w.appendChild(l);return {wrap:w,label:l};
}
function btn(cls,text,pressed,note,onClick){
  var b=el('button',cls,text);b.type='button';
  b.setAttribute('aria-pressed',pressed?'true':'false');
  if(note){var s=el('span','yct-pick__note',note);b.appendChild(s);}
  b.addEventListener('click',onClick);return b;
}

function init(){
  var vs=document.querySelector('variant-selects');
  var cSel=sel('Color')||sel('Colour'), sSel=sel('Size'), slSel=sel('Sleeve');
  if(!vs||!sSel)return;
  if(document.querySelector('.yct-pick'))return;

  var sizes=vals(sSel), colors=cSel?vals(cSel):[], sleeves=slSel?vals(slSel):[];
  var groups={};
  sizes.forEach(function(v){var g=group(v);(groups[g]=groups[g]||[]).push(v);});
  var cats=ORDER.filter(function(g){return groups[g]&&groups[g].length;});
  var cat=group(sSel.value);
  if(cats.indexOf(cat)===-1)cat=cats[0];

  var root=el('div','yct-pick');
  var n=1;

  if(cats.length>1){
    var st=step(n+++'. Select your size category');
    var row=el('div','yct-pick__seg');row.setAttribute('data-cols',String(Math.min(cats.length,3)));
    cats.forEach(function(g){
      row.appendChild(btn('yct-pick__btn',LABEL[g],g===cat,null,function(){
        if(cat===g)return;cat=g;
        if(groups[g].indexOf(sSel.value)===-1)set(sSel,groups[g][0]);
        render();
      }));
    });
    st.wrap.appendChild(row);root.appendChild(st.wrap);
  }

  if(sleeves.length>1){
    var st2=step(n+++'. Select sleeve style');
    var row2=el('div','yct-pick__seg');row2.setAttribute('data-cols','2');
    sleeves.forEach(function(v){
      var note=/long/i.test(v)?'+$5.00':null;
      row2.appendChild(btn('yct-pick__btn',v,slSel.value===v,note,function(){set(slSel,v);render();}));
    });
    st2.wrap.appendChild(row2);root.appendChild(st2.wrap);
  }

  if(colors.length){
    var st3=step(n+++'. Select colour',cSel.value);
    var row3=el('div','yct-pick__sw');
    colors.forEach(function(v){
      var hex=SWATCH[String(v).toLowerCase()];
      var b=el('button',hex?'yct-pick__swatch':'yct-pick__swatch yct-pick__chip',hex?null:v);
      b.type='button';if(hex)b.style.background=hex;
      b.title=v;b.setAttribute('aria-label',v);
      b.setAttribute('aria-pressed',cSel.value===v?'true':'false');
      b.addEventListener('click',function(){set(cSel,v);render();});
      row3.appendChild(b);
    });
    st3.wrap.appendChild(row3);root.appendChild(st3.wrap);
  }

  var st4=step(n+++'. Select size',cats.length>1?LABEL[cat]:null);
  var row4=el('div','yct-pick__sizes');
  st4.wrap.appendChild(row4);root.appendChild(st4.wrap);

  var guide=document.querySelector("variant-selects a[href*='size-guide'], variant-selects a[href*='size_guide']");
  if(guide)st4.label.appendChild(guide);

  vs.parentNode.insertBefore(root,vs);
  document.body.classList.add('yct-pick-on');

  function render(){
    cat=group(sSel.value);
    if(cats.indexOf(cat)===-1)cat=cats[0];
    root.querySelectorAll('.yct-pick__step').forEach(function(s,i){
      var btns=s.querySelectorAll('.yct-pick__btn, .yct-pick__swatch');
      btns.forEach(function(b){
        var t=(b.getAttribute('aria-label')||b.childNodes[0]&&b.childNodes[0].nodeValue||'').trim();
        if(LABEL[cat]===t)b.setAttribute('aria-pressed','true');
      });
    });
    if(cats.length>1){
      root.querySelectorAll('.yct-pick__seg[data-cols] .yct-pick__btn').forEach(function(b){
        var t=(b.childNodes[0]&&b.childNodes[0].nodeValue||'').trim();
        if(LABEL[cat]!==undefined&&ORDER.map(function(g){return LABEL[g];}).indexOf(t)!==-1)
          b.setAttribute('aria-pressed',t===LABEL[cat]?'true':'false');
        if(sleeves.indexOf(t)!==-1)b.setAttribute('aria-pressed',slSel.value===t?'true':'false');
      });
    } else if(sleeves.length>1){
      root.querySelectorAll('.yct-pick__btn').forEach(function(b){
        var t=(b.childNodes[0]&&b.childNodes[0].nodeValue||'').trim();
        if(sleeves.indexOf(t)!==-1)b.setAttribute('aria-pressed',slSel.value===t?'true':'false');
      });
    }
    root.querySelectorAll('.yct-pick__swatch').forEach(function(b){
      b.setAttribute('aria-pressed',b.getAttribute('aria-label')===cSel.value?'true':'false');
    });
    var q=st3&&st3.label.querySelector('.yct-pick__qual');if(q)q.textContent=cSel.value;
    var q4=st4.label.querySelector('.yct-pick__qual');if(q4)q4.textContent=LABEL[cat];
    row4.textContent='';
    (groups[cat]||[]).forEach(function(v){
      row4.appendChild(btn('yct-pick__size',v,sSel.value===v,null,function(){set(sSel,v);render();}));
    });
  }

  vs.addEventListener('change',function(){setTimeout(render,0);});
  render();
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
})();

/* ---- two-step buy flow ---------------------------------------------
   Step 1 is the option picker, step 2 is personalisation plus the buy
   buttons. Both panes stay in the DOM and are only toggled, so uploaded
   photos and typed text survive moving between steps -- nothing is
   re-rendered and no navigation happens.
   Keeping the buy block in step 2 also stops the dynamic checkout button
   being used to skip personalisation entirely.
   Styles live in yct-picker.css so they share its asset version. */
(function(){
'use strict';

function el(t,c,txt){var e=document.createElement(t);if(c)e.className=c;if(txt!=null)e.textContent=txt;return e;}
function optVal(n){var s=document.querySelector("select[name='options["+n+"]']");return s?s.value:'';}

function init(){
  var col=document.querySelector('.productView-product');
  if(!col)return false;
  if(col.querySelector('.yct-steps__bar'))return true;
  if(!document.querySelector('.yct-pick'))return false;

  var pane1=col.querySelector('.productView-moreItem-product-variant');
  var pane2=col.querySelector('[id^="pwz-personalization-"]');
  if(!pane1||!pane2)return false;
  if(pane1.parentNode!==col||pane2.parentNode!==col)return false;
  var buy=pane2.nextElementSibling;

  var bar=el('div','yct-steps__bar');
  var crumb=el('p','yct-steps__crumb');
  var back=el('button','yct-steps__back','Change shirt');
  back.type='button';
  bar.appendChild(crumb);bar.appendChild(back);
  col.insertBefore(bar,pane1);

  var cont=el('div','yct-steps__continue');
  var go=el('button','yct-steps__btn','Continue');
  go.type='button';
  var warn=el('p','yct-steps__warn');
  cont.appendChild(go);cont.appendChild(warn);
  col.insertBefore(cont,pane2);

  function unavailable(){
    var b=document.querySelector('#product-add-to-cart');
    if(!b)return false;
    var t=(b.textContent||'').toLowerCase();
    return b.disabled||t.indexOf('sold out')!==-1||t.indexOf('unavailable')!==-1;
  }
  function chosen(){
    var bits=[optVal('Color')||optVal('Colour'),optVal('Size'),optVal('Sleeve')];
    return bits.filter(function(v){return v;}).join('  /  ');
  }
  function show(n){
    pane1.classList.toggle('yct-steps__hide',n!==1);
    cont.classList.toggle('yct-steps__hide',n!==1);
    pane2.classList.toggle('yct-steps__hide',n!==2);
    if(buy)buy.classList.toggle('yct-steps__hide',n!==2);
    back.classList.toggle('yct-steps__hide',n!==2);
    crumb.textContent='';
    crumb.appendChild(document.createTextNode(n===1?'Step 1 of 2 - ':'Step 2 of 2 - '));
    crumb.appendChild(el('b',null,n===1?'Choose your shirt':chosen()));
    warn.textContent='';
    if(n===2&&bar.scrollIntoView)bar.scrollIntoView({block:'nearest'});
  }

  go.addEventListener('click',function(){
    if(unavailable()){
      warn.textContent='That combination is not available. Pick a different colour or size.';
      return;
    }
    show(2);
  });
  back.addEventListener('click',function(){show(1);});
  show(1);
  return true;
}

var tries=0;
function boot(){
  if(init())return;
  if(++tries>50)return;
  setTimeout(boot,100);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
